
import { Avatar, Container, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import HeaderSession from '../utils/headerSession'
import RegisterAccess from '../utils/registerAccess'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import api from '../services/api'
import FerramentaNavegacaoExportacao from '../utils/paginacao'
import StatusEstabelecimento from '../utils/status/statusEstabelecimento'
import Loading from '../load/loading'
import SearshEstabelecimento from '../utils/searchEstabelecimento';
import { useParams, useSearchParams } from 'react-router-dom'
import { EstabelecimentosLicenciadosexcel } from '../admin/exports/gerarelatorioexcel'
import { EstabelecimentosLicenciadospdf } from '../admin/exports/gerarelatoriopdf'

export default function ListaPublicaEstabelecimentosLicenciados() {
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const d = searchParams.get("d"); //designacao
    const [estabelecimentos, setEstabelecimentos] = useState(useSelector(state => state?.estabelecimentoLicenciados?.data) ?? '')
    const [configLista, setConfigLista] = useState(useSelector(state => state?.estabelecimentoLicenciados?.config) ?? '')
    const [page, setPage] = useState(1);
    const dispatch = useDispatch();
    const [perPage, setPerPage] = useState(100)
    const [order, setOrder] = useState('DESC')
    const [loading, setLoading] = useState(false);
    // const [tipo, setTipo] = useState('');
    const [provincia, setProvincia] = useState('');

    useEffect(() => {
        setLoading(true)
        setEstabelecimentos('')
        api.get(`/estabelecimentos?page=${page}&perPage=${perPage}&sortBy=createdAt:${order}&status=Activo&provincia=${provincia}&tipoId=${id}`)
            .then(response => {
                // setEstabelecimentos(response.data.estabelecimentos);
                setConfigLista(response.data);
                setEstabelecimentos((prevItems) => [...prevItems, ...response.data.estabelecimentos]);

            }).catch(err => { }).
            finally(() => { setLoading(false) })

        dispatch({
            type: 'estabelecimentoLicenciados',
            payload: { estabelecimentoLicenciados: estabelecimentos, config: configLista },
        }); //dispatch para por os estabelecimentos no state da aplicacao e evitar recarregar desnecessariamente

    }, [page, perPage, order, provincia, id]);


    return (
        <Container style={{ minHeight: '70vh', minWidth: '90vw' }}>
            <RegisterAccess page={'Estabelecimentos Licenciados'} />
            <HeaderSession
                title={`ESTABELECIMENTOS LICENCIADOS / ${d?.toUpperCase()}`}
                actions={true}
                handleExportExcel={() => EstabelecimentosLicenciadosexcel(estabelecimentos)}
                handleExportPDF={() => EstabelecimentosLicenciadospdf(estabelecimentos)}
            />

            <SearshEstabelecimento
                setEstabelecimentos={setEstabelecimentos}
                // setTipo={setTipo}
                placeholder={'Pesquisar'}
                setProvincia={setProvincia}
                filtroCategorias={false}
                filtroStatus={false}
                provincia={provincia}
            />


            {estabelecimentos &&

                <TableContainer sx={{ border: "1px black" }} component={Paper}>
                    <Table sx={{ border: "1px", borderColor: "black" }}>
                        <TableHead sx={{ backgroundColor: "#dcdede" }}>
                            <TableRow>
                                <TableCell ><Typography noWrap> <strong>Imagem</strong></Typography></TableCell>
                                <TableCell ><Typography noWrap> <strong>Nome</strong></Typography></TableCell>
                                <TableCell ><Typography noWrap> <strong>Tipo</strong></Typography></TableCell>
                                <TableCell ><Typography noWrap> <strong>Nif</strong></Typography></TableCell>
                                {/* <TableCell ><Typography noWrap> <strong>Número de Processo</strong></Typography></TableCell> */}
                                <TableCell ><Typography noWrap> <strong>Presentante</strong></Typography></TableCell>
                                <TableCell ><Typography noWrap> <strong>Director Técnico</strong></Typography></TableCell>
                                <TableCell ><Typography noWrap> <strong>Provincia</strong></Typography></TableCell>
                                <TableCell ><Typography noWrap> <strong>Estado</strong></Typography></TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {estabelecimentos.map((estabelecimento) => (
                                <TableRow key={estabelecimento._id} >

                                    <TableCell component="th" scope="row">
                                        <Avatar variant='square' src={estabelecimento?.logo} alt={estabelecimento?.nome} />
                                    </TableCell>

                                    <TableCell >{estabelecimento?.nome?.toUpperCase()}</TableCell>
                                    <TableCell >{estabelecimento?.tipo?.designacao}</TableCell>
                                    <TableCell >{estabelecimento?.empresa?.nif ?? '###'}</TableCell>
                                    {/* <TableCell >{estabelecimento?.numeroProcesso}</TableCell> */}
                                    <TableCell >{estabelecimento?.empresa?.representante?.dadosPessoais?.nome?.toUpperCase()}</TableCell>
                                    <TableCell >{estabelecimento?.directorTecnico?.dadosPessoais?.nome?.toUpperCase()}</TableCell>
                                    <TableCell >{estabelecimento?.provincia}</TableCell>
                                    <TableCell >
                                        <StatusEstabelecimento status={estabelecimento?.status} />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>

                    <FerramentaNavegacaoExportacao
                        configLista={configLista}
                        lista={estabelecimentos}
                        page={page}
                        setPage={setPage}
                        setPerPage={setPerPage}
                        setOrder={setOrder}
                    // exportarExcel={exportarExcel}
                    />

                </TableContainer>
            }

            {loading && <Loading text={'Lista Actualizada de Estabelecimentos Farmacêuticos Autorizados.'} />}

        </Container>
    )
}
